import React from 'react';
import T from 'i18n-react';
import PDF from 'react-pdf-js';
import PropTypes from 'prop-types';
import Spinner from '../Spinner';


const SignDocument = ({ documentUrl, onSubmit, progressBar, paxDisplayName, isLoading }) => (
  <div>
    <div className="container">
      <h1 className="container__header">
      {`${T.translate('signDocument')} ${paxDisplayName}`}
      </h1>
      {isLoading ? (
        <React.Fragment>
          <Spinner />
          <h3>{T.translate('waitForDoc')}</h3>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div>{documentUrl && <PDF file={documentUrl} />}</div>
          <div className="row valider" style={{ justifyContent: 'flex-end' }}>
            <a className="btn" href={documentUrl} download="LOA.pdf" target="_blank">
              {T.translate("download")}
            </a>
            <button className="btn" onClick={onSubmit}>
              {T.translate('sign')}
            </button>
          </div>
        </React.Fragment>
        )}
      </div>
      {!isLoading && progressBar}
  </div>
);

SignDocument.propTypes = {
  documentUrl: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  progressBar: PropTypes.element.isRequired,
  paxDisplayName: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

export default SignDocument;



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/SignDocument.js